import type { Catalog } from '../../catalog';
import {
  resolveAbilityImageUrl,
  resolveHeroImageUrl,
  resolveItemImageUrl
} from '../../utils/dotaAssets';
import {
  resolveAbilityDisplayName,
  resolveHeroDisplayName,
  resolveItemDisplayName
} from '../../utils/dotaNames';
import { LOCALE } from '../../i18n';

export type StatisticsEntityKind = 'hero' | 'ability' | 'item';

const DETAIL_SEGMENT: Record<StatisticsEntityKind, string> = {
  hero: 'heroes',
  ability: 'abilities',
  item: 'items'
};

export const statisticsDetailPath = (kind: StatisticsEntityKind, name: string): string =>
  `/statistics/${DETAIL_SEGMENT[kind]}/${encodeURIComponent(name)}`;

export const resolveEntityDisplayName = (
  catalog: Catalog,
  kind: StatisticsEntityKind,
  name: string
): string => {
  if (kind === 'hero') return resolveHeroDisplayName(catalog, name);
  if (kind === 'ability') return resolveAbilityDisplayName(catalog, name);
  return resolveItemDisplayName(catalog, name);
};

export const resolveEntityImageUrl = (
  catalog: Catalog,
  kind: StatisticsEntityKind,
  name: string
): string => {
  if (kind === 'hero') return resolveHeroImageUrl(catalog, name);
  if (kind === 'ability') return resolveAbilityImageUrl(catalog, name);
  return resolveItemImageUrl(catalog, name);
};

export const formatPct = (value?: number | null): string =>
  new Intl.NumberFormat(LOCALE, {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }).format(value || 0);

export const formatMono = (value?: number | null, digits = 1): string => {
  if (value == null || Number.isNaN(value)) return '—';
  return new Intl.NumberFormat(LOCALE, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(value);
};

export const formatInt = (value?: number | null): string => {
  if (value == null || Number.isNaN(value)) return '—';
  return new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 0 }).format(value);
};
